// Entry point for the build script in your package.json
import "@hotwired/turbo-rails"
require("@rails/activestorage").start()
require("./channels")
require('./mobile_apps/turbolinks_adapter')

import "./controllers"
import Rails from '@rails/ujs'

Rails.start()

document.addEventListener('touchstart', function() {}, { passive: true });
